import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { updateActiveGroup } from '../userInterface'
import { Order } from './models/Order'
import { ordersAdapter } from './ordersAdapters'
import { fetchOrder } from './thunks/fetchOrder'
import { saveOrder } from './thunks/saveOrder'

export const initialOrderState = ordersAdapter.getInitialState()

export const ordersSlice = createSlice({
  name: 'orders',
  initialState: initialOrderState,
  reducers: {
    upsertMultipleOrders: (state, action) => {
      ordersAdapter.upsertMany(state, action.payload)
    },
    removeAllOrders: ordersAdapter.removeAll,
    replaceAllOrders: (state, action: PayloadAction<Order[]>) => {
      ordersAdapter.setAll(state, action.payload)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveOrder.fulfilled, (state, action: PayloadAction<Order | null>) => {
        if (action.payload) {
          ordersAdapter.upsertOne(state, action.payload)
        }
      })
      .addCase(fetchOrder.fulfilled, (state, action: PayloadAction<Order | null>) => {
        if (action.payload) {
          ordersAdapter.upsertOne(state, action.payload)
        }
      })
      .addCase(updateActiveGroup.fulfilled, (state) => {
        // Clear orders when group changes
        ordersAdapter.removeAll(state)
      })
  },
})

export const { upsertMultipleOrders, removeAllOrders, replaceAllOrders } = ordersSlice.actions